import FakeDataProvider from "ra-data-fakerest";

const AnonymousDataProvider = FakeDataProvider({
    task: [],
    project: [],
    lot: [],
    team: [],
    user: [],
    workflow: [],
    stage: [],
    stage_infos: [],
    production_unit: [],
    team_member: [],
    user_role: [],
    ref_role: []
});

export default AnonymousDataProvider;